import {
  Box,
  Chip,
  Tooltip,
  Typography
  } from "@mui/material";
import { ContestWithId } from "../../interfaces/IContests";
import { formatDateTime } from "../../utils/dates";
import { useRegistrationValidation } from "../../hooks/useRegistrationValidation";

interface RegistrationStatusProps {
  contest: ContestWithId;
}

export default function RegistrationStatus({ contest }: RegistrationStatusProps) {
  const registrationStatus = useRegistrationValidation(contest);

  const getStatusLabel = () => {
    if (registrationStatus.isCompleted) {
      return "ZAMKNIĘTA";
    }
    if (!registrationStatus.isStarted) {
      return "NIEROZPOCZĘTA";
    }
    return registrationStatus.isOpen ? "OTWARTA" : "ZAMKNIĘTA";
  };

  const getStatusColor = (): "success" | "error" | "warning" | "default" => {
    if (registrationStatus.isCompleted) {
      return "error";
    }
    if (!registrationStatus.isStarted) {
      return "warning";
    }
    return registrationStatus.isOpen ? "success" : "error";
  };

  const getStatusText = () => {
    if (registrationStatus.isOpen) {
      return `do ${formatDateTime(contest.registrationEnd)}`;
    }
    if (!registrationStatus.isStarted) {
      return `od ${formatDateTime(contest.registrationStart)}`;
    }
    return `do ${formatDateTime(contest.registrationEnd)}`;
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.8rem" }}>
        Rejestracja:
      </Typography>
      <Tooltip title={registrationStatus.reason || ""} arrow>
        <Chip
          label={getStatusLabel()}
          size="small"
          color={getStatusColor()}
          sx={{ fontWeight: 500, height: 20, fontSize: "0.7rem" }}
        />
      </Tooltip>
      <Typography variant="body2" sx={{ fontSize: "0.8rem" }}>
        {getStatusText()}
      </Typography>
    </Box>
  );
}
